<template>
<div v-loading.fullscreen.lock="fullscreenLoading">
  <Slick ref="slick" :options="slickOptions" class="slick-item">
    <div><a href="https://bit.ly/3n8rCnv" target="_blank"><img src="/static/renew_img/bnr/mypage_top_banner_20220622.png"></a></div>
  </Slick>
  <section class="flex">
	  <article class="content-wrapper" v-if="$firebase.isAuthenticated">
      <div class="content-wrapper" style="padding-bottom: 0px !important;">
        <ul class="timeline">
          <li v-for="(backup, index) in backupList['user'].slice(0,1)"
                  :key="index">
            <div class="btn_wrapper" v-if="index == 0">
              <p class="date">{{ $formLib.dateFormat(backup.value.timestamp, 'yyyy年mm月dd日HH時MM分') }}</p>
              <p class="os">{{ backup.value.platform }}::{{index}}</p>
              <a class=" btn_cta"  @click.prevent="confirmBackup(backup)"
                  style="background-color:#E95B10;border-color:#E95B10;">この職務経歴書を選択 <br><span>(プレビュー)</span></a>
            </div>
          </li>
        </ul>
        <section id="more">
          <input id="acd-title-more" class="acd-check-more" type="checkbox">
          <label class="acd-label-more" for="acd-title-more">もっと見る ▼</label>
          <div class="acd-content-more">
            <ul class="timeline">
              <li v-for="(backup, index) in backupList['user'].slice(1)"
                  :key="index">
                <div class="circle"></div>
                <div class="vertical-line"></div>
                <div class="btn_wrapper">
                  <p class="date">{{ $formLib.dateFormat(backup.value.timestamp, 'yyyy年mm月dd日HH時MM分') }} 更新</p>
                  <p class="os">{{ backup.value.platform }}</p>
                  <a class=" btn_cta" @click.prevent="confirmBackup(backup)"
                  style="background-color:#E95B10;border-color:#E95B10;">この職務経歴書を選択 <br><span>(プレビュー)</span></a>
                </div>
              </li>
            </ul>
          </div>
        </section>
        <div class="btn_wrapper">
          <div class="btn_backup" style="background-color:#004D40" v-if="false">
            <el-button :disabled="saved"
                         type="success"
                          style="background-color:#004D40;border-color:#004D40;"
                         @click="saveBackup">バックアップを作成する</el-button>
          </div>
          <router-link v-if="recentEdit.FormatId !== ''" :to="{name: 'formatEditCard', params: { formatId: recentEdit.FormatId, cardId: recentEdit.cardId }}"
                      style="background-color:#E95B10;border-color:#E95B10;"
                      v-ripple class="btn_cta">続きから入力する
          </router-link>
          <p v-if="recentEdit.FormatId !== ''" class="orange animation1 keyframe7" style="color:#E3165C;">↑PDF・コンビニ印刷もこちら↑</p>
        </div>
      </div>
      <div class="content-wrapper">
        <a href="https://lin.ee/0rfNtli" target="_blank" ><img src="/static/renew_img/banner_line.png" class="banner-line pc"></a>
      </div>		
    </article>
    <article v-else　class="content-wrapper" >
      <div class="action">
        <p>バックアップにはログインが必要です</p>
      </div>
    </article>
　</section>

	<section class="banner-contents" v-if="false">
		<ul class="banner-box">
			<li>
				<a href="https://bit.ly/39KLMRh" target="_blank"><img src="/static/renew_img/bnr/mypage_middle_banner_20211229_001.png" class="banner"></a>
			</li>
		</ul>
	</section>
	
	<div class="content-wrapper">
		<a href="https://lin.ee/0rfNtli" target="_blank" ><img src="/static/renew_img/banner_line.png" class="banner-line sp"></a>
	</div>		







  <modal name="confirm-backup-dialog"
          :adaptive="true"
          :scrollable="true"
          height="auto"
          @opened="setPreviewScale();previewLoading=false">
    <div class="v--modal-close-top">
      <el-button @click="closeDialog"
                  icon="el-icon-close"
                  type="text"></el-button>
    </div>
    <div v-if="backupDataToConfirm"
          class="backup-preview-dialog">
      <div class="formats-info">
        <div class="title">
          <p>{{ formattedBackupData.label }}</p>
        </div>
        <div class="date">{{ $formLib.dateFormat(formattedBackupData.lastSaveDate, 'yyyy年mm月dd日HH時MM分') }}</div>
        <div class="system">{{ formattedBackupData.platform }}</div>
      </div>
        <el-tabs v-model="activePreviewTab"
                  class="backup-tabs"
                  :stretch="true"
                  @tab-click="setPreviewScale();previewLoading=false"
                  >
          <el-tab-pane label="職務経歴書"
                        name="format_shokumukeirekisho"
                        :lazy="true"
                        :style="backupDataViewerCssShokurekisho"
                        >
                        <shokurekisho-preview ref="backupDataViewer"
                                              :id-prefix="'backup'"
                                              :format-data="formattedBackupData.format_shokumukeirekisho"
                                              :basic-data="formattedBackupData.basicData"
                                              :preview-scale="previewScale"></shokurekisho-preview>
          </el-tab-pane>
          <el-tab-pane label="履歴書"
                        name="format_rirekisho"
                        :lazy="true"
                        :style="backupDataViewerCssRirekisho"
                        >
                        <rirekisho-preview ref="backupDataViewer"
                                          :id-prefix="'backup'"
                                          :format-data="formattedBackupData.format_rirekisho"
                                          :basic-data="formattedBackupData.basicData"
                                          :preview-scale="previewScale"></rirekisho-preview>
          </el-tab-pane>
        </el-tabs>
        <!-- </br> -->
      <div class="delete delete-confirm"
            v-if="!deleteBackupPopoverVisible">
        <div class="delete-text-button">
          <el-button @click="deleteBackupPopoverVisible = true"
                      type="text"
                      icon="el-icon-delete">このバックアップを削除する</el-button>
        </div>
      </div>
      <div class="delete delete-confirm"
            v-else>
        <div style="text-align: right; margin: 0">
          <el-button @click="deleteBackupPopoverVisible = false">キャンセル</el-button>
          <el-button @click="deleteBackup(backupDataToConfirm)"
                      type="danger"><i class="el-icon-delete"></i> 削除する</el-button>
        </div>
        <p>削除すると元には戻せませんのでご注意ください</p>
      </div>
    </div>

    <div class="text-right">
      <el-button type="primary"
                  @click="loadBackup(backupDataToConfirm)">復元する</el-button>
      <el-button @click="closeDialog">閉じる</el-button>
    </div>
    <br/><br/>
  </modal>
	<section class="btn_top"><a class="btn_sub" style="background-color:#FFFFFF;border-color:#E95B10;color:#E95B10" href="/">トップへ戻る</a></section>

	<section id="setting" style="background-color:#ffd6d6;" v-if="$firebase.isAuthenticated">
		<div class="content-wrapper">
      <input id="acd-title" class="acd-check" type="checkbox">
      <label class="acd-label" for="acd-title">設定<img src="/static/renew_img/icon_setting_pink.svg"></label>
      <div class="acd-content">
        <div class="delite">
          <a href="/account/delete" class="btn_green">データ・アカウントの削除</a>
          <p>ブラウザ内に保存されたデータや、サーバーへのバックアップデータ、登録アカウントを削除できます</p>
        </div>
        <div class="logout">
          <el-button id="google-logout-account-dialog"
            @click="$firebase.signOut();$event.preventDefault()">ログアウト</el-button>
        </div>
      </div>
		</div>
	</section>

</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
</style>

<script>
import {
  TabPane,
  Tabs
} from 'element-ui'
import RirekishoPreview from '@/components/formats/RirekishoPreview'
import ShokurekishoPreview from '@/components/formats/ShokurekishoPreview'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'rirekisho-preview': RirekishoPreview,
    'shokurekisho-preview': ShokurekishoPreview,
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    Slick
  },
  data: function () {
    return {
		  fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      backupList: {
        auto: [],
        user: []
      },
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions:{
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      activeTabName: 'user',
      // activePreviewTab: 'format_rirekisho'
      activePreviewTab: 'format_shokumukeirekisho'
    }
  },
  computed: {
    formattedBackupData: function () {
      if (!this.backupDataToConfirm) return {}
      const content = JSON.parse(this.backupDataToConfirm.value.content)
      return {
        lastSaveDate: this.backupDataToConfirm.value.lastSaveDate,
        label: this.backupDataToConfirm.value.label,
        format_rirekisho: content.format_rirekisho || {},
        format_shokumukeirekisho: content.format_shokumukeirekisho || {},
        basicData: content.basicData || {},
        platform: this.backupDataToConfirm.value.platform
      }
    }
  },
  methods: {
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.$refs.backupDataViewer.$el.clientWidth === 0) {
        } else {
          const clientWidth = this.$refs.backupDataViewer.$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_HEIGHT_PX)
          // console.log(clientWidth, this.previewScale)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height = this.$refs.backupDataViewer.$refs.previewMain.getBoundingClientRect().height
      // const height = 10
      if (!height) {
        return
      }
      if (this.activePreviewTab === 'format_rirekisho' && height > 0) {
        this.backupDataViewerCssRirekisho = {
          height: height + 30 + 'px'
        }
      } else if (this.activePreviewTab === 'format_shokumukeirekisho' && height > 0) {
        this.backupDataViewerCssShokurekisho = {
          height: height + 30 + 'px'
        }
      }
    },
    openDialog: function () {
      this.$modal.show('confirm-backup-dialog')
      this.backupDataViewerCssRirekisho = {}
      this.backupDataViewerCssShokurekisho = {}
    },
    closeDialog: function () {
      this.$modal.hide('confirm-backup-dialog')
      this.deleteBackupPopoverVisible = false
    },
    confirmBackup: function (backup) {
      // console.log(backup)
      this.backupDataToConfirm = backup
      this.previewLoading = true
      this.openDialog()
    },
    setDefaultSaveLabel: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
    },
    saveBackup: function () {
      if (this.$yagi.profile.name) {
        this.saveLabel = this.$yagi.profile.name + 'のバックアップ'
      } else {
        this.saveLabel = 'バックアップ'
      }
      this.$firebase.addBackup(this.saveLabel, 'user')
      this.loadBackupList('user')
      this.saved = true
    },
    loadBackupList: function (type) {
      const app = this
      app.backupListLoaded[type] = false
      app.backupList[type] = []
      app.$firebase.getBackupList('all', 5)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            app.backupList[type].push({
              id: doc.id,
              value: doc.data()
            })
          })
          app.backupListLoaded[type] = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    loadBackup: function (backup) {
      this.$firebase.loadBackup(backup.id)
      this.closeDialog()
    },
    deleteBackup: function (backup) {
      this.$firebase.deleteBackupWithMessage(backup.id, backup.value.label)
      console.log('deleteBackup', backup)
      this.getBackups(true)
      this.closeDialog()
    },
    dataChanged: function () {
      this.saved = false
      this.setDefaultSaveLabel()
    },
    loadRecentEdit: function () {
      const app = this
      this.$getItem(RECENT_EDIT_SAVE_KEY, function (err, data) {
        if (err) {
          console.log(err)
        }
        if (data) {
          app.recentEdit = data
        }
      })
    },
    getBackups: function (force) {
      if (this.$deviceLib.isOnline && this.$firebase.isAuthenticated) {
        if (force) {
          this.loadBackupList('auto')
          this.loadBackupList('user')
        } else {
          if (!this.backupListLoaded['user']) {
            this.loadBackupList('user')
          }
          if (!this.backupListLoaded['auto']) {
            this.loadBackupList('auto')
          }
        }
      }
    }
  },
  created: function () {
    console.log('created')
    this.loadRecentEdit()
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        var refreshToken = user.refreshToken
	      this.fullscreenLoading = false
      } else {
          this.$router.push('/login')
      }
    })
  },
  beforeMount: function () {
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
    this.$eventHub.$on('firebase-initialized', this.getBackups)
    this.$eventHub.$on('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$on('yagi-profile-saved', this.setDefaultSaveLabel)
    this.setDefaultSaveLabel()
    this.getBackups()
  },
  destroyed: function () {
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
    this.$eventHub.$off('firebase-initialized', this.getBackups)
    this.$eventHub.$off('yagi-profile-loaded', this.setDefaultSaveLabel)
    this.$eventHub.$off('yagi-profile-saved', this.setDefaultSaveLabel)
  }
}
</script>
